'use strict';
accountActivityController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$interval',
	'dialogHelper',
	'reportHelper',
	'authService',
	'unitService',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('accountActivityController', accountActivityController);

function accountActivityController(
	$scope,
	$rootScope,
	$q,
	$interval,
	dialogHelper,
	reportHelper,
	authService,
	unitService,
	USER_CLAIMS,
	BUSY_MESSAGE
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');

	$scope.$watch(
		'vm.report.dateFrom',
		function (changed, old) {
			// Ensure endDT is equal or greater to startDT each time startDT changes.
			if (!_.isUndefined(changed) && changed !== null) {
				if (_.isUndefined($scope.vm.report.dateTo) || _.isNull($scope.vm.report.dateTo)) {
					$scope.vm.report.dateTo = changed;
					return;
				}

				if (moment(changed).startOf('day') > moment($scope.vm.report.dateTo).startOf('day')) {
					$scope.vm.report.dateTo = changed;
					return;
				}
			}
		},
		true
	);

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.vm = viewModel;

	$scope.loadingPromise = $q.all([LoadFiscalYears($scope.vm), LoadFiscalMonths($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			message: BUSY_MESSAGE.Loading,
			fiscalMonths: [],
			fiscalYears: [],
			report: {
				byFYOrDateRange: '0',
				fiscalYear: null,
				fiscalMonth: 0,
				thirteenthMonth: false,
				dateFrom: moment().toDate(),
				dateTo: moment().toDate(),
				includeOutstandingPOs: false,
				excludeZeroBalanceAccounts: true,
				groupBy: 'Element',
				groupings: null,
			},
			validationErrors: [],
			accessPayroll: false,
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (model.report.byFYOrDateRange === '0') {
				if (!model.report.fiscalYear) {
					model.validationErrors.push('Please select a Fiscal Year.');
					isValid = false;
				}

				if (!model.report.monthName && model.report.thirteenthMonth !== true) {
					model.validationErrors.push('Please select a Month.');
					isValid = false;
				}
			} else {
				if (!model.report.dateFrom) {
					model.validationErrors.push("Please select a 'From' date.");
					isValid = false;
				}

				if (!model.report.dateTo) {
					model.validationErrors.push("Please select a 'To' date.");
					isValid = false;
				}

				if (isValid === true && moment(model.report.dateFrom).startOf('day') > moment(model.report.dateTo).startOf('day')) {
					model.validationErrors.push('Date Range is invalid!');
					isValid = false;
				}

				// Make sure same Fiscal Year
				const fyBegMonth = parseInt(moment().month(model.fiscalMonths[0]).format('M'));
				const fyEndMonth = parseInt(
					moment()
						.month(model.fiscalMonths[model.fiscalMonths.length - 1])
						.format('M')
				);
				const endMonth = parseInt(moment(model.report.dateTo).format('M'));
				let fiscalYear = parseInt(moment(model.report.dateTo).format('YYYY'));
				if (fyEndMonth - endMonth < 0) {
					fiscalYear += 1;
				}
				const fyBegDT = moment([fiscalYear - 1, fyBegMonth - 1, 1]);
				const fyEndDT = moment(fyBegDT).add(1, 'years').subtract(1, 'days');
				if (moment(model.report.dateFrom) < fyBegDT || moment(model.report.dateTo) > fyEndDT) {
					model.validationErrors.push('Dates must be within the same fiscal year!');
					isValid = false;
				}
			}

			if (model.report.groupBy === 'Element') {
				angular.forEach(model.report.groupings, function (g) {
					angular.forEach(g.rangeRows, function (r) {
						if (isValid === true) {
							if (r.ElementIndex === null || r.ElementIndex.length === 0) {
								model.validationErrors.push('One or more rows is missing a selected Element!');
								isValid = false;
							}
							if (r.FromValue === 'undefined' || r.FromValue === null || r.FromValue.length === 0) {
								model.validationErrors.push("One or more rows is missing a 'From' Value!");
								isValid = false;
							}
							if (r.RangeOption === 'range') {
								if (r.ToValue === 'undefined' || r.ToValue === null || r.ToValue.length === 0) {
									model.validationErrors.push("One or more rows is missing a 'To' Value!");
									isValid = false;
								}
							}
						}
					});
				});
			}

			return isValid;
		}

		function thirteenthMonthSelected(model) {
			if (model.report.thirteenthMonth) {
				model.report.includeThirteenthMonth = false;
				model.report.monthName = model.fiscalMonths[model.fiscalMonths.length - 1];
			}
		}

		function openReport(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Account Activity Report Error!', null, model.validationErrors, 'Warning');
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var GroupCol = [];
			if (model.report.groupBy === 'Element') {
				angular.forEach(model.report.groupings, function (g) {
					angular.forEach(g.rangeRows, function (r) {
						var gItem = {
							ElementName: g.elementsMinMaxList[r.ElementIndex].ElementName,
							FilterBy: r.RangeOption,
							FromValue: String(r.FromValue) || '0',
							ToValue: String(r.ToValue) || '0',
							SubTotal: r.SubTotal,
							PageBreak: r.PageBreak,
						};
						if (r.RangeOption === 'equals') {
							gItem.ToValue = String(r.FromValue) || '0';
						}
						GroupCol.push(gItem);
					});
				});
			}

			var report = {
				ByDateRange: model.report.byFYOrDateRange !== '0',
				FiscalYear: model.report.fiscalYear,
				FiscalMonth: model.fiscalMonths.indexOf(model.report.monthName) + 1,
				MonthName: model.report.monthName,
				ThirteenthMonth: model.report.thirteenthMonth,
				DateFrom: moment(model.report.dateFrom).format('l'),
				DateTo: moment(model.report.dateTo).format('l'),
				IncludeOutstandingPOs: model.report.includeOutstandingPOs,
				ExcludeZeroBalanceAccounts: model.report.excludeZeroBalanceAccounts,
				GroupByElements: GroupCol,
			};

			reportHelper.getReport($scope, '/api/fundreports/accountactivityreport', report, 'AccountActivityReport.pdf');
		}

		return angular.extend(model, {
			thirteenthMonthSelected: _.partial(thirteenthMonthSelected, model),
			openReport: _.partial(openReport, model),
		});
	}

	function LoadFiscalYears(model) {
		return unitService.getFiscalYears().then(_.partial(finishLoadingYears, model));

		function finishLoadingYears(model, response) {
			model.fiscalYears = response.data.fiscalYears;
			model.report.fiscalYear = response.data.currentFiscalYear;
			return angular.noop;
		}
	}

	function LoadFiscalMonths(model) {
		return unitService.getFiscalMonths().then(_.partial(finishLoadingMonths, model));

		function finishLoadingMonths(model, response) {
			model.fiscalMonths = response.data.fiscalMonths;
			model.lastFiscalMonth = response.data.fiscalMonths[model.fiscalMonths.length - 1];
			model.report.monthName = moment().format('MMMM');
			return angular.noop;
		}
	}
}
